import Axios from "axios";
import React, { useState } from "react";
import { api_url } from "../../../config";
import Bouton from "../../common/HorsConnexion/Bouton";
import Compte from "../../common/HorsConnexion/Compte";
import EcranResultat from "../../common/HorsConnexion/EcranResultat";
import FormulaireMotDePasse from "../../common/HorsConnexion/FormulaireMotDePasse";
import {
  MESSAGE_SERVEUR_INDISPONIBLE,
  extraireErreurMotDePasse,
  interpreterErreurLien,
} from "../../common/HorsConnexion/horsConnexion";
import PageHorsConnexion from "../../common/HorsConnexion/PageHorsConnexion";
import PiedCarte from "../../common/HorsConnexion/PiedCarte";

// Adresse lisible pour l'affichage seulement (le lien peut l'encoder, ex. %40) ;
// l'API reçoit le paramètre tel qu'avant.
const adresseLisible = (email) => {
  try {
    return decodeURIComponent(email);
  } catch (e) {
    return email;
  }
};

/**
 * Nouveau mot de passe depuis le lien reçu par e-mail. Même appel qu'avant
 * (POST recipients/renew-password/ avec token, email, password) ; l'échec d'un
 * lien (expiré, déjà utilisé, invalide) s'affiche en écran dédié.
 */
const RenewPassword = (props) => {
  const { token, email } = props.match.params;
  const [vue, setVue] = useState(token && email ? "formulaire" : "invalide");
  const [enregistrement, setEnregistrement] = useState(false);
  const [erreurMdp, setErreurMdp] = useState(null);
  const [erreurGenerale, setErreurGenerale] = useState(null);

  function enregistrer(password) {
    setEnregistrement(true);
    setErreurGenerale(null);
    Axios.post(api_url + "recipients/renew-password/", { token, email, password })
      .then(() => setVue("succes"))
      .catch((err) => {
        const messageMdp = extraireErreurMotDePasse(err.response && err.response.data);
        if (messageMdp) {
          setErreurMdp(messageMdp);
          return;
        }
        const resultat = interpreterErreurLien(err);
        if (resultat === "indisponible") setErreurGenerale(MESSAGE_SERVEUR_INDISPONIBLE);
        else setVue(resultat);
      })
      .then(() => setEnregistrement(false));
  }

  const nouveauLien = (
    <>
      <Bouton to={{ pathname: "/", state: { vue: "oubli" } }}>Demander un nouveau lien</Bouton>
      <Bouton secondaire to="/">
        Retour à la connexion
      </Bouton>
    </>
  );

  return (
    <PageHorsConnexion>
      {vue === "formulaire" && (
        <section aria-labelledby="titre-nouveau-mdp">
          <h1 id="titre-nouveau-mdp">Nouveau mot de passe</h1>
          <p className="sous-titre">
            Choisissez le mot de passe de votre espace allocataire. Il remplacera l'ancien dès
            l'enregistrement.
          </p>
          <Compte email={adresseLisible(email)} />
          <FormulaireMotDePasse
            onEnregistrer={enregistrer}
            enregistrement={enregistrement}
            erreurMdp={erreurMdp}
            onEffacerErreurMdp={() => setErreurMdp(null)}
            erreurGenerale={erreurGenerale}
          />
          <PiedCarte signature={false}>Ce lien est valable 24 heures et ne sert qu'une fois.</PiedCarte>
        </section>
      )}
      {vue === "succes" && (
        <EcranResultat ton="succes" icone="coche" titre="Mot de passe enregistré">
          <p>Votre nouveau mot de passe est actif. Vous pouvez à présent vous connecter.</p>
          <Bouton to="/">Se connecter</Bouton>
        </EcranResultat>
      )}
      {vue === "expire" && (
        <EcranResultat ton="avert" icone="horloge" titre="Ce lien a expiré">
          <p>
            Les liens de réinitialisation sont valables <strong>24 heures</strong>. Celui-ci n'est plus
            utilisable.
          </p>
          {nouveauLien}
        </EcranResultat>
      )}
      {vue === "utilise" && (
        <EcranResultat ton="info" icone="info" titre="Ce lien a déjà été utilisé">
          <p>
            Un lien de réinitialisation ne sert qu'une fois. Si vous n'êtes pas à l'origine de ce
            changement, demandez un nouveau lien sans attendre.
          </p>
          {nouveauLien}
        </EcranResultat>
      )}
      {vue === "invalide" && (
        <EcranResultat ton="danger" icone="croix" titre="Ce lien est invalide">
          <p>
            Il est peut-être tronqué ou mal recopié. Ouvrez-le directement depuis l'e-mail que vous avez
            reçu.
          </p>
          {nouveauLien}
        </EcranResultat>
      )}
    </PageHorsConnexion>
  );
};

export default RenewPassword;
